module.exports = __webpack_public_path__ + "assets/img/Henry Park Primary School.b30188e8.jpg";